import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHandler, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { ObjectWrapper } from '../models/ObjectWrapper';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
interface WeatherForecast {
  date: string;
  temperatureC: number;
  temperatureF: number;
  summary: string;
}
const httpOptions = {
  headers: new HttpHeaders({
    'Content-type': 'text/plain'
  })
}
@Injectable({ providedIn: "root" })

export class HttpService {
  base: string;
  constructor(private client: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.base = environment.ServerRootAddress;// environment.ServerRootAddress;
    //this.base = "http://localhost:43464/";
  }
  LoadTestActuators(): Promise<ObjectWrapper> {
    return firstValueFrom(this.client.get<ObjectWrapper>(this.base + 'Data/GetActuators/true', httpOptions));    
  }

  LoadActuators(): Promise<ObjectWrapper> {    
    return firstValueFrom(this.client.get<ObjectWrapper>(this.base + 'Data/GetActuators/false', httpOptions));    
  }

  LoadFeedbackCodes(): Promise<ObjectWrapper> {
    return firstValueFrom(this.client.get<ObjectWrapper>(this.base + 'Data/GetFeedbackCodes', httpOptions));
  }

  LoadFeedbackDevice(code: string): Promise<ObjectWrapper> {
    return firstValueFrom(this.client.get<ObjectWrapper>(this.base + 'Data/GetFeedbackDevice/' + code, httpOptions));
  }

  LoadMFGs(mfgType:string): Promise<ObjectWrapper> {
    
    return firstValueFrom(this.client.get<ObjectWrapper>(this.base + 'Data/GetManufacturers/' + mfgType, httpOptions));
  }

  GetConnector(feedbackCode: string, motor:string): Promise<ObjectWrapper> {
    return firstValueFrom(this.client.get<ObjectWrapper>(this.base + 'Data/GetConnector/' + feedbackCode + '/' + motor, httpOptions));
  }

  GetSuggestedCable(feedbackCode: string, driveSeriesRowPointer: string, motor:string, brakeSelected: boolean): Promise<ObjectWrapper> {
    return firstValueFrom(this.client.get<ObjectWrapper>(this.base + 'Data/GetSuggestedCable/' + feedbackCode + '/' + driveSeriesRowPointer + '/' + motor + '/' + brakeSelected.toString(), httpOptions));
  }

  
}
